import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';
import { ANNOTATION_TYPES } from './annotationTypes';
import './AnnotationLegend.css';

// Compact, foldable legend explaining what each annotation colour means.
// Without it, translators see rainbow-coloured words and have to discover the
// meaning by hovering each one. The legend collapses to a single line by
// default so it doesn't dominate small screens.


function AnnotationLegend() {
  const { t } = useTranslation('chat');
  const [open, setOpen] = useState(false);

  return (
    <div className={`annotation-legend ${open ? 'open' : ''}`}>
      <button
        className="annotation-legend-toggle"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <Info size={14} />
        <span>{t('legend.title', 'What do the colours mean?')}</span>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>

      {open && (
        <div className="annotation-legend-body">
          {ANNOTATION_TYPES.map(({ type, i18nKey }) => (
            <div key={type} className="annotation-legend-item">
              <span className={`annotation-legend-swatch type-${type}`} />
              <div className="annotation-legend-text">
                <span className="annotation-legend-label">
                  {t(`legend.${i18nKey}.label`)}
                </span>
                <span className="annotation-legend-desc">
                  {t(`legend.${i18nKey}.desc`)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AnnotationLegend;
